<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_first_name" class="col-sm-3 mb-0">
						First Name
					</label>
					<app-input
						id="inputs_first_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.first_name"
						placeholder="First Name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_last_name" class="col-sm-3 mb-0">
						Last Name
					</label>
					<app-input
						id="inputs_last_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.last_name"
						placeholder="Last Name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_date_of_birth" class="col-sm-3 mb-0">
						Date of Birth
					</label>
					<app-input
						id="inputs_date_of_birth"
						class="col-sm-9"
						type="date"
						v-model="inputs.date_of_birth"
						placeholder="Date of Birth"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_school_name" class="col-sm-3 mb-0">
						School Name
					</label>
					<app-input
						id="inputs_school_name"
						class="col-sm-9"
						type="date"
						v-model="inputs.school_name"
						placeholder="School Name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_school_level" class="col-sm-3 mb-0">
						School Level
					</label>
					<app-input
						id="inputs_school_level"
						class="col-sm-9"
						type="date"
						v-model="inputs.school_level"
						placeholder="School Level"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_status" class="col-sm-3 mb-0">
						Status
					</label>
					<app-input
						id="inputs_status"
						class="col-sm-9"
						type="search-select"
						:list="status_list"
						v-model="inputs.status"
						placeholder="Status"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_clc_id_no" class="col-sm-3 mb-0">
						CLC ID No
					</label>
					<app-input
						id="inputs_clc_id_no"
						class="col-sm-9"
						type="text"
						v-model="inputs.clc_id_no"
						placeholder="CLC ID No"
						:required="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";

export default {
	name: "ChildrenInfoTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {},
			phone: "",
			modalId: this.formId,
			modalTitle: this.$t("add"),
			status_list: [
				{ id: "lead", value: "Lead" },
				{ id: "student", value: "Student" },
				{ id: "opportunity", value: "Opportunity" },
				{ id: "ex_student", value: "Ex Student" },
			],
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
